import { SITE, FOOTER_COLUMNS } from '@config/siteConfig';
import {
  ICON_SOCIAL_1,
  ICON_SOCIAL_2,
  ICON_SOCIAL_3,
  ICON_SOCIAL_4,
} from '@config/assets';
import styles from './Footer.module.css';

const SOCIAL_ICONS = [
  // { src: ICON_SOCIAL_1, label: 'Social 1' },
  // { src: ICON_SOCIAL_2, label: 'Social 2' },
  // { src: ICON_SOCIAL_3, label: 'Social 3' },
  // { src: ICON_SOCIAL_4, label: 'Social 4' },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      {/* ---- Divider ---- */}
      <div className={styles.divider} />

      <div className={styles.inner}>
        {/* ---- Brand column ---- */}
        <div className={styles.brandCol}>
          <p className={styles.siteName}>{SITE.name}</p>
          <div className={styles.socials}>
            {SOCIAL_ICONS.map(({ src, label }) => (
              <a
                key={label}
                href="#"
                className={styles.socialIcon}
                aria-label={label}
              >
                <img src={src} alt="" width={24} height={24} />
              </a>
            ))}
          </div>
        </div>

        {/* ---- Topic columns ---- */}
        {FOOTER_COLUMNS.map((col, idx) => (
          <div key={idx} className={styles.col}>
            <p className={styles.colHeading}>{col.heading}</p>
            <ul className={styles.colLinks}>
              {col.links.map((link, i) => (
                <li key={i}>
                  <a href={link.path} className={styles.colLink}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  );
}
